module.exports = "/assets/data/d635185d7c87810ab2e301423ce7ba89-NR12.data.json";